function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.99 2.144a2.644 2.644 0 012.663 2.662c0 1.484-1.178 2.713-2.662 2.713-1.485 0-2.662-1.229-2.662-2.713A2.644 2.644 0 016.99 2.144zm0 1.024c-.921 0-1.638.716-1.638 1.638 0 .921.717 1.689 1.639 1.689.921 0 1.638-.768 1.638-1.69 0-.92-.717-1.637-1.638-1.637z",
  fill: "#3A3A3A"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.796 3.116c-.563.359-1.126-.512-.563-.87 4.454-2.969 9.061-3.02 13.566 0 .512.358-.051 1.229-.614.82C9.09.3 4.943.351.796 3.115z",
  fill: "#3A3A3A"
});

function SvgEyeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgEyeinline;